module.exports = __webpack_public_path__ + "img/login-new-square-4.d5b144aa.png";